import styled from "styled-components";

import { QUERIES, SPACING } from "../../utils/constants";
import { FooterStyleProps } from "./types";

export const Footer = styled.div<FooterStyleProps>`
  margin-top: ${SPACING.sm}px;
  border-top: 1px solid var(--color-border);

  @media ${QUERIES.tabletLargeAndUp} {
    display: ${({ $isMobileOnly }) => ($isMobileOnly ? "none" : "block")};
  }
`;
